import { observable } from "mobx";
import { api } from "../../api";
import { IContador, IEndereco, newIEndereco } from "../../model";
import { toast } from "react-toastify";

class _ContadorDialogStore {
  obs = observable({
    endereco: {} as IEndereco,
    status_ok: false as boolean,
    contadores_list: [] as IContador[],
    cep_is_valid: false as boolean,
    contador_selected: "" as string,
    is_edit: false as boolean,
    contador: {} as IContador,
    isOpen_contador: false as boolean,
  })

  constructor() {
  }

  handleGetEnderecoForCEP = async (cep: number) => {
    try {
      let resp = await api.get(`/api/viacep/${cep}`);

      if (resp.data.erro) {
        this.obs.cep_is_valid = false;
        this.obs.endereco = newIEndereco();

        toast.error('CEP Inválido', {});
      } else {
        this.obs.endereco = resp.data;
        this.obs.cep_is_valid = true;
      }
    } catch (err) {
      toast.error(`Erro ao carregar Endereço Cep, tente novamente mais tarde.`, {});
      this.obs.endereco = newIEndereco();
      this.obs.cep_is_valid = false;
    }
  };

  handleCreateContador = async (obj: IContador) => {

    try {

      obj.cpf = obj.cpf.replace(/\./g, "").replace("-", "");

      let resp = await api.post("/api/contador", obj);

      if (resp.data === "ok") {
        this.obs.status_ok = true;
        toast.success('Contador criado com sucesso', {});
        await this.handleGetContadores();
        this.obs.isOpen_contador = false

      } else {
        this.obs.status_ok = false;
        toast.error('Não foi possível criar, tente novamente mais tarde', {});
      }
    } catch (ex) {
      toast.error("Erro ao criar Contador, tente novamente mais tarde.", {});
    }
  };

  handlePutContador = async (obj: IContador) => {
    try {

      obj.cpf = obj.cpf.replace(/\./g, "").replace("-", "");

      let resp = await api.put("/api/contador", obj);

      if (resp.data === "ok") {
        this.obs.status_ok = true;
        toast.success('Contador editado com sucesso', {});

        await this.handleGetContadores();
        this.obs.isOpen_contador = false

      } else {
        this.obs.status_ok = false;
        toast.error('Não foi possível editar, tente novamente mais tarde', {});
      }
    } catch (ex) {
      toast.error("Erro ao editar Contador, tente novamente mais tarde.", {});
    }
  };

  handleGetContadores = async () => {
    try {
      let resp = await api.get("/api/contador-list");
      if (Array.isArray(resp.data)) {
        this.obs.contadores_list = resp.data;
      }
    } catch (ex) {
      toast.error("Erro ao consultar total, tente novamente mais tarde.", {});
      this.obs.contadores_list = [];
    }
  };

  handleDeleteContador = async (id: string) => {
    try {
      let resp = await api.delete(`/api/contador/${id}`);

      if (resp.data === "ok") {
        this.obs.status_ok = true;
      } else {
        this.obs.status_ok = false;
      }
    } catch (ex) {
      toast.error("Erro ao deletar Contador, tente novamente mais tarde.", {});
    }
  };
}

export const ContadorDialogStore = new _ContadorDialogStore();
